export class ConnectRestoreAwsOrganizationalUnitResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "organizationalUnit",
            "baseName": "organizationalUnit",
            "type": "RestoreAwsOrganizationalUnit",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectRestoreAwsOrganizationalUnitResponse.attributeTypeMap;
    }
    constructor() {
    }
}
